<template>
    <section>

        <div class="top-bar">
            <el-input v-model="input" @change="searchVal()" placeholder="搜索用户" prefix-icon="el-icon-search" style="margin-right:25px;width:200px" clearable></el-input>
        </div>
        <el-card shadow="hover">
            <el-table :data="tableData"  @selection-change="handleChecked" max-height="500"  ref="table"  style="width: 100%">
                <el-table-column    label="用户头像"  align="center" >
                    <template slot-scope="scope">
                         <m-img v-if="scope.row.pic_url" :src="scope.row.pic_url"></m-img>
                         <img v-else src="@/assets/mooby.png" alt="" style="width:70px;height:70px;">
                    </template>
                </el-table-column>
                <el-table-column  prop="nickname" label="姓名"     align="center" show-overflow-tooltip></el-table-column>
                <el-table-column  prop="phone"    label="手机号码" align="center"></el-table-column>
                <el-table-column  prop="signin_count"    label="累计签到" align="center"></el-table-column>
            </el-table>
            <el-pagination background layout="prev, pager, next, jumper"  style="padding:10px" :total="total" :page-size="size"  @current-change="loadMore"></el-pagination>
        </el-card>
        
    </section>
</template>


<script>
import { user_sign } from '@/api/market.js'
import MImg  from '@/components/Image'
export default {
    components: { MImg },
    data() {
        return {
            input:'',
            tableData: [],
            total: 0,
            page: 1,
            size: 20,
        }
    },
    methods: {
        searchVal() {
            this.page = 1;
            this.handleData()
        },
        // 获取分类数据
        handleData(){
            let params = {
                page:this.page
            }
            if (this.input != '') {
                params.search = this.input
            }
            user_sign(params).then(res => {
                if(res){
                    this.tableData = res.data.data
                    this.total     = res.data.total
                    this.size      = res.data.per_page
                } else {
                    this.tableData = []
                }
            })
        },
        loadMore(page) {
            this.page = page;
            this.handleData();
        }
    },
    created(){
        this.handleData();
    },
    activated() {
        this.handleData()
    },
}
</script>

<style lang="less" scoped>
    section{
        .top-btn {
            width: 80px;
            margin-right: 15px;
        }
        .line-item {
            margin-bottom: 20px;
        }
        .input-left {
            height: 40px;
            line-height: 40px;
        }
    }
</style>